import { Check } from 'lucide-react';

interface WizardProgressProps {
  currentStep: number;
  totalSteps: number;
  labels: string[];
}

const WizardProgress = ({ currentStep, totalSteps, labels }: WizardProgressProps) => {
  return (
    <div className="w-full">
      {/* Step circles + connecting lines */}
      <div className="flex items-center justify-between">
        {Array.from({ length: totalSteps }, (_, i) => {
          const isCompleted = i < currentStep;
          const isCurrent = i === currentStep;

          return (
            <div key={i} className="flex items-center flex-1 last:flex-none">
              {/* Circle */}
              <div className="flex flex-col items-center">
                <div
                  className={`
                    w-10 h-10 rounded-full flex items-center justify-center text-sm font-semibold
                    transition-all duration-300 shrink-0
                    ${
                      isCompleted
                        ? 'bg-vivatis-600 text-white'
                        : isCurrent
                          ? 'bg-vivatis-600 text-white ring-4 ring-vivatis-200 dark:ring-vivatis-900'
                          : 'bg-gray-200 text-gray-500 dark:bg-gray-700 dark:text-gray-400'
                    }
                  `}
                >
                  {isCompleted ? <Check size={18} strokeWidth={3} /> : i + 1}
                </div>
              </div>

              {/* Connecting line (not after last step) */}
              {i < totalSteps - 1 && (
                <div className="flex-1 mx-3">
                  <div
                    className={`
                      h-0.5 w-full rounded-full transition-colors duration-300
                      ${
                        i < currentStep
                          ? 'bg-vivatis-600'
                          : 'bg-gray-200 dark:bg-gray-700'
                      }
                    `}
                  />
                </div>
              )}
            </div>
          );
        })}
      </div>

      {/* Labels below circles */}
      <div className="flex justify-between mt-3">
        {labels.map((label, i) => {
          const isCompleted = i < currentStep;
          const isCurrent = i === currentStep;

          return (
            <div
              key={i}
              className={`
                text-xs sm:text-sm font-medium text-center transition-colors duration-300
                ${
                  i === 0
                    ? 'text-left w-10 sm:w-auto'
                    : i === labels.length - 1
                      ? 'text-right w-10 sm:w-auto'
                      : 'w-10 sm:w-auto'
                }
                ${
                  isCompleted || isCurrent
                    ? 'text-vivatis-700 dark:text-vivatis-400'
                    : 'text-gray-400 dark:text-gray-500'
                }
              `}
            >
              {label}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default WizardProgress;
